<template>
  <div class="col-12 grid-margin">
    <div id="loadingmessage"
      style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
      v-if="loading">
      <p style="position: absolute; color: White; top: 40%; left: 50%;">
        <img src="../../assets/loader.gif" />
      </p>
    </div>
    <div v-if="isstat" class="card">
      <div class="card-body">
        <h4 class="card-title">Edit a Turtle</h4>
        <form class="form-sample" @submit="onSubmit">
          <div class="col-md-6 pt-4 pb-4 pl-0">
            <div class="row">
              <div class="col-md-6 form-group" style="font-size:16px!important">
                <label for="exampleInputEmail1">Please Enter Turtle Image</label>
                <br />

                <input type="file" class="images" accept="image/*" id="file7" ref="file7"
                  v-on:change="handleFileUpload7()" />
                <p v-if="url7">{{ data.turtleImage }}</p>

                <!--input input type="file" :name="'images' + (index + 1)" accept="image/*" @change="previewImage(index, $event)"-->
              </div>
              <div class="col-md-4">
                <div width="80px" height="80px" id="preview">
                  <img width="100%" height="100%" :src="url7" />
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="font-size:16px!important">
            <div class="col-md-4 pb-2">
              <b-form-group label="Name">
                <b-form-input type="text" v-model="name" required></b-form-input>
              </b-form-group>
            </div>

            <div class="col-md-4 pb-2">
              <b-form-group label="Scientific Name">
                <b-form-input type="text" v-model="sci_name" required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4 pb-2">
              <b-form-group label="Common Name">
                <b-form-input type="text" v-model="common_name" required></b-form-input>
              </b-form-group>
            </div>
            <hr class="pt-2" />

            <div class="col-md-4">
              <b-form-group label="WLPA">
                <b-form-input type="text" v-model="wlpa"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Cites">
                <b-form-input type="text" v-model="cites"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="IUCN">
                <b-form-input type="text" v-model="iucn"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Morphology">
                <b-form-textarea id="textarea4" v-model="morphology" placeholder="Morphology"
                  rows="5"></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Color">
                <b-form-textarea id="textarea" v-model="color" placeholder="Color" rows="5"></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Dimorphism">
                <b-form-textarea id="textarea1" v-model="dimorphism" placeholder="Dimorphism"
                  rows="5"></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="size">
                <b-form-textarea id="textarea2" v-model="size" placeholder="Size" rows="5"></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Habitat">
                <b-form-textarea id="textarea5" v-model="habitat" placeholder="Habitat" rows="5"></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Diet">
                <b-form-textarea id="textarea6" v-model="diet" placeholder="Diet" rows="5"></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Nesting">
                <b-form-input type="text" v-model="nesting"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <label>Type</label>
              <select id="type" class="form-control" name="Chooae Type" required placeholder="Choose Type"
                v-model="type">
                <option></option>
                <option value="Hard-Shell Turtle">Hard-Shell Turtle</option>
                <option value="Soft-Shell Turtle">Soft-Shell Turtle</option>
                <option value="Tortoise">Tortoise</option>
              </select>
            </div>

            <div class="col-md-4">
              <b-form-group label="Threats">
                <b-form-input type="text" v-model="threats"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Distribution">
                <b-form-textarea id="textarea10" v-model="distribution" placeholder="Distribution"
                  rows="5"></b-form-textarea>
              </b-form-group>
            </div>
          </div>
          <h4 class="pt-5" style="font-size:24px!important">Uploading Images</h4>
          <div class="row pt-3">
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-7 form-group">
                  <label for="exampleInputEmail1">Please Enter Image of Male Carapace</label>
                  <br />

                  <input type="file" class="images" accept="image/*" id="file1" ref="file1"
                    v-on:change="handleFileUpload1()" />
                  <p v-if="url">{{ data.male_carapace }}</p>
                </div>
                <div class="col-md-4">
                  <div width="60px" height="60px">
                    <img width="100%" height="100%" :src="url" />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="row">
                <div class="col-md-7 form-group">
                  <label for="exampleInputEmail1">Please Enter Image of Female Carapace</label>
                  <br />

                  <input type="file" class="images" accept="image/*" id="file2" ref="file2"
                    v-on:change="handleFileUpload2()" />
                  <p v-if="url2">{{ data.female_carapace }}</p>
                </div>
                <div class="col-md-4">
                  <div id="preview">
                    <div width="60px" height="60px">
                      <img width="100%" height="100%" :src="url2" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 pt-2">
              <div class="row">
                <div class="col-md-7 form-group">
                  <label for="exampleInputEmail1">Please Enter Image of Male Plastron</label>
                  <br />

                  <input type="file" class="images" accept="image/*" id="file3" ref="file3"
                    v-on:change="handleFileUpload3()" />
                  <p v-if="url3">{{ data.male_plastron }}</p>
                </div>
                <div class="col-md-4">
                  <div width="60px" height="60px">
                    <img width="100%" height="100%" :src="url3" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 pt-2">
              <div class="row">
                <div class="col-md-7 form-group">
                  <label for="exampleInputEmail1">Please Enter Image of Female Plastron</label>
                  <br />

                  <input type="file" class="images" accept="image/*" id="file4" ref="file4"
                    v-on:change="handleFileUpload4()" />
                  <p v-if="url4">{{ data.female_plastron }}</p>
                </div>
                <div class="col-md-4">
                  <div width="60px" height="60px">
                    <img width="100%" height="100%" :src="url4" />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 pt-2">
              <div class="row">
                <div class="col-md-7 form-group">
                  <label for="exampleInputEmail1">Please Enter Image of Identification!</label>
                  <br />

                  <input type="file" class="images" accept="image/*" id="file5" ref="file5"
                    v-on:change="handleFileUpload5()" />
                  <p v-if="url5">{{ data.identification1 }}</p>
                </div>
                <div class="col-md-4">
                  <div width="60px" height="60px">
                    <img width="100%" height="100%" :src="url5" />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 pt-2">
              <div class="row">
                <div class="col-md-7 form-group">
                  <label for="exampleInputEmail1">Please Enter Image of Identification2</label>
                  <br />

                  <input type="file" class="images" accept="image/*" id="file6" ref="file6"
                    v-on:change="handleFileUpload6()" />
                  <p v-if="url6">{{ data.identification2 }}</p>
                  <!-- {{url6}} -->
                  <!--input input type="file" :name="'images' + (index + 1)" accept="image/*" @change="previewImage(index, $event)"-->
                </div>
                <div class="col-md-4">
                  <div width="60px" height="60px">
                    <img width="100%" height="100%" :src="url6" />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 pt-4">
              <div class="row">
                <div class="col-md-7 form-group">
                  <label for="exampleInputEmail1">Please Enter Map Image</label>
                  <br />

                  <input type="file" class="images" accept="image/*" id="file8" ref="file8"
                    v-on:change="handleFileUpload8()" />
                  <p v-if="url8">{{ data.mapImage }}</p>
                  <!-- {{url8}} -->
                  <!--input input type="file" :name="'images' + (index + 1)" accept="image/*" @change="previewImage(index, $event)"-->
                </div>
                <div class="col-md-4">
                  <div width="60px" height="60px">
                    <img width="100%" height="100%" :src="url8" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <label for="exampleInputEmail1">More Images</label>
            <div class="input-group-prepend">
              <input type="file" accept="image/*" id="file" ref="files" multiple="multiple" @change="onFileChanged2" />
            </div>
          </div>
          <div class="row pt-3" id="preview">
            <div v-for="(item, i) in imarr" :key="i" class="col-md-2">
              <div class="pt-2">
                <img width="60px" height="60px" v-if="item" :src="baseURL + item" />
                <i style="font-size:15px;padding-left:10px;" @click=" imgremove1(item)" class="fa fa-close pb-0"></i>
              </div>

              <br />
            </div>
            <div v-for="(item, i) in urlarr" :key="i" class="col-md-2">
              <div class="pt-2">
                <img width="60px" height="60px" v-if="item" :src="item" />
                <i style="font-size:15px;padding-left:10px;" @click=" imgremove(item)" class="fa fa-close pb-0"></i>
              </div>

              <br />
            </div>
          </div>

          <hr />
          <b-button variant="primary" class="btn-fw" type="submit">Submit</b-button>
        </form>
      </div>
    </div>
    <div v-else>
      <b>Sorry!!Please Try Again Later or Do a Refresh!!</b>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "editaturtle",
  props: ["id"],
  data: () => {
    return {
      loading: false,
      sci_name: "",
      data: [],
      name: "",
      common_name: "",
      type: "",
      cites: "",
      wlpa: "",
      iucn: "",
      morphology: "",
      color: "",
      dimorphism: "",
      size: "",
      habitat: "",
      diet: "",
      nesting: "",
      distribution: "",
      threats: "",
      female_carapace: "",
      male_carapace: "",
      male_plastron: "",
      female_plastron: "",
      identification1: "",
      identification2: "",
      turtleImage: "",
      mapImage: "",
      loading: false,
      previewurl: baseURL,
      file1: "",
      file2: "",
      file3: "",
      file4: "",
      file5: "",
      file6: "",
      file7: "",
      file8: "",
      url: null,
      url2: null,
      url3: null,
      url4: null,
      url5: null,
      url6: null,
      url7: null,
      url8: null,
      urlarr: [],
      turt: new FormData(),
      selectedFiles: null,
      isstat: false,
      immarr: [],
    };
  },
  mounted: function () {
    this.getDetails();
  },
  methods: {
    onFileChanged2(event) {
      this.selectedFiles = event.target.files[0];
      this.turt.append("image", this.selectedFiles);
      var img;
      img = new Image();
      img.src = window.URL.createObjectURL(event.target.files[0]);
      img.onload = () => {
        const urls = URL.createObjectURL(this.selectedFiles);
        if (this.urlarr.length < 4) {
          this.urlarr.push(urls);
        } else {
          this.seen = false;
          this.msg = "Four Images Already Addted!";
          this.showsnackbar = true;
        }

        // console.log( this.url1)
        // this.uploadImage();
      };
    },
    uploadImages() {
      this.turt.append("id", this.id);
      this.turt.append("male_carapace", this.file1);
      this.turt.append("female_carapace", this.file2);
      this.turt.append("male_plastron", this.file3);
      this.turt.append("female_plastron", this.file4);
      this.turt.append("identification1", this.file5);
      this.turt.append("identification2", this.file6);
      this.turt.append("turtleImage", this.file7);
      this.turt.append("mapImage", this.file8);
      console.log(this.turt);
      axios({
        method: "post",
        url: "/turtle/uploadImagesingle",
        data: this.turt,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then((response) => {
          if (response.data.status === true) {
            this.loading = false;

            alert("Updated Successfully");

            this.$router.push({ path: "/listturtles" });
          }
          if (response.data.status === false) {
            this.loading = false;
            // alert("Image upload failed..please Try Again");
            // window.location.reload();
          }
        })

        .catch((e) => {
          console.log(e);
          this.loading = false;
        });
    },
    getDetails() {
      this.loading = true;
      var data1 = {};
      data1["id"] = this.id;
      axios({
        method: "GET",
        url: "/turtle/get?id=" + this.id,
        data: data1,
      })
        .then((response) => {
          this.loading = false;
          this.isstat = response.data.status;
          if (response.data.status === true) {
            this.data = response.data.data;
            this.name = response.data.data.name;
            this.common_name = response.data.data.common_name;
            this.sci_name = response.data.data.sci_name;
            this.type = response.data.data.type;
            this.cites = response.data.data.cites;
            this.iucn = response.data.data.iucn;
            this.wlpa = response.data.data.wlpa;
            this.morphology = response.data.data.morphology;
            this.color = response.data.data.color;
            this.dimorphism = response.data.data.dimorphism;
            this.size = response.data.data.size;
            this.habitat = response.data.data.habitat;
            this.diet = response.data.data.diet;
            this.nesting = response.data.data.nesting;
            this.distribution = response.data.data.distribution;
            this.threats = response.data.data.threats;
            // this.urlarr=response.data.data.image
            this.imarr = response.data.data.image;

            if (response.data.data.male_carapace != null) {
              this.url = this.previewurl + response.data.data.male_carapace;
            }
            if (response.data.data.female_carapace != null) {
              this.url2 = this.previewurl + response.data.data.female_carapace;
            }
            if (response.data.data.male_plastron != null) {
              this.url3 = this.previewurl + response.data.data.male_plastron;
            }
            if (response.data.data.female_plastron != null) {
              this.url4 = this.previewurl + response.data.data.female_plastron;
            }
            if (response.data.data.identification1 != null) {
              this.url5 = this.previewurl + response.data.data.identification1;
            }
            if (response.data.data.identification2 != null) {
              this.url6 = this.previewurl + response.data.data.identification2;
            }
            if (response.data.data.turtleImage != null) {
              this.url7 = this.previewurl + response.data.data.turtleImage;
            }
            if (response.data.data.mapImage != null) {
              this.url8 = this.previewurl + response.data.data.mapImage;
            }
            //   var temp=[]
            //   for(i=0;i<response.data.data.image.length;i++)
            //   {
            //     var ty=this.previewurl+response.data.data.image[i]
            //     temp.push(ty)
            //   }

            //  this.urlarr=temp
            // var temp={}
            // for(var j=0;j<response.data.data.image.length;j++)
            // {
            //   var ty=response.data.data.image[j]
            //   temp.push(ty)
            // }
            this.loading = false;
          } else if (response.data.status === false) {
            this.loading = false;
          }
        })
        .catch((e) => {
          this.loading = false;
          alert("Something went wrong");
          this.errors.push(e);
          this.msg = "failed";
        });
    },
    handleFileUpload1() {
      this.file1 = this.$refs.file1.files[0];
      this.url = URL.createObjectURL(this.file1);
    },
    handleFileUpload2() {
      this.file2 = this.$refs.file2.files[0];
      this.url2 = URL.createObjectURL(this.file2);
    },
    handleFileUpload3() {
      this.file3 = this.$refs.file3.files[0];
      this.url3 = URL.createObjectURL(this.file3);
    },
    handleFileUpload4() {
      this.file4 = this.$refs.file4.files[0];
      this.url4 = URL.createObjectURL(this.file4);
    },
    handleFileUpload5() {
      this.file5 = this.$refs.file5.files[0];
      this.url5 = URL.createObjectURL(this.file5);
    },
    handleFileUpload6() {
      this.file6 = this.$refs.file6.files[0];
      this.url6 = URL.createObjectURL(this.file6);
    },
    handleFileUpload7() {
      this.file7 = this.$refs.file7.files[0];
      this.url7 = URL.createObjectURL(this.file7);
    },
    handleFileUpload8() {
      this.file8 = this.$refs.file8.files[0];
      this.url8 = URL.createObjectURL(this.file8);
    },

    imgremove(index) {
      this.urlarr.splice(index, 1);
    },
    imgremove1(index) {
      this.imarr.splice(index, 1);
    },

    onSubmit(evt) {
      evt.preventDefault();
      this.loading = true;
      var edit = {};
      edit["id"] = this.id;
      edit["x-auth-token"] = localStorage.getItem("token");
      edit["name"] = this.name;
      edit["common_name"] = this.common_name;
      edit["sci_name"] = this.sci_name;
      edit["type"] = this.type;
      edit["cites"] = this.cites;
      edit["wlpa"] = this.wlpa;
      edit["iucn"] = this.iucn;
      edit["morphology"] = this.morphology;
      edit["color"] = this.color;
      edit["dimorphism"] = this.dimorphism;
      edit["size"] = this.size;
      edit["habitat"] = this.habitat;
      edit["diet"] = this.diet;
      edit["nesting"] = this.nesting;
      edit["distribution"] = this.distribution;
      edit["threats"] = this.threats;

      axios({
        method: "post",
        url: "/turtle/edit",
        data: edit,
      })
        .then((response) => {
          if (response.data.status === true) {
            this.uploadImages();
          }
          if (response.data.status === false) {
            this.loading = false;

            alert("please Try Again");
            this.$router.push({ path: "/editaturtle" });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.card-body>>>table>tbody>tr>td {
  cursor: pointer;
}
</style>